export default __webpack_public_path__ + "static/media/ruki.2971c105.png";